import { render, staticRenderFns } from "./ThirdComp.vue?vue&type=template&id=149b9aa7&scoped=true&"
import script from "./ThirdComp.vue?vue&type=script&lang=js&"
export * from "./ThirdComp.vue?vue&type=script&lang=js&"
import style0 from "./ThirdComp.vue?vue&type=style&index=0&id=149b9aa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b9aa7",
  null
  
)

export default component.exports